import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// Import Data
import { menuItems } from './LayoutMenuData';

import { useAppDispatch, useAppSelector } from 'slices';
import { changeSidebarVisibility } from 'slices/sidebar/reducer';
import useGetPestCompany from 'hooks/Clients/useGetPestCompany';
import { useEditCompanyPestModalStore } from 'pages/ClientDashboardV2/hooks/EditCompanyPestModalStore';

const HorizontalLayout = () => {
  document.documentElement.setAttribute('data-layout', 'vertical');

  /*
layout settings
*/

  // const { data } = useClientCompanyData();
  const { visibility, isActive, companySlug } = useAppSelector(state => state.Layout);
  const [menuItemsTake, setMenuItemsTake] = useState('');
  const { onManageEditMapOpen } = useEditCompanyPestModalStore();
  const dispatch = useAppDispatch();
  var windowSize = document.documentElement.clientWidth;
  const prevWidthRef = useRef(document.documentElement.clientWidth);
  const prevHeightRef = useRef(document.documentElement.clientHeight);
  const resizeSidebarMenu = useCallback(() => {
    const currentWidth = document.documentElement.clientWidth;
    const currentHeight = document.documentElement.clientHeight;

    if (currentWidth === prevWidthRef.current || currentHeight === prevHeightRef.current) {
      return;
    }

    prevWidthRef.current = currentWidth;
    prevHeightRef.current = currentHeight;
    const humberIcon = document.querySelector('.hamburger-icon') as HTMLElement;
    var hamburgerIcon = document.querySelector('.hamburger-icon');
    if (windowSize >= 1280) {
      if (document.documentElement.getAttribute('data-layout') === 'vertical') {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
      if (document.documentElement.getAttribute('data-layout') === 'semibox') {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      if (visibility === 'show' && document.querySelector('.hamburger-icon')) {
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.remove('open');
        }
      } else {
        // var hamburgerIcon = document.querySelector(".hamburger-icon");
        if (hamburgerIcon !== null) {
          hamburgerIcon.classList.add('open');
        }
      }
    } else if (windowSize < 1280 && windowSize > 767) {
      document.body.classList.remove('twocolumn-panel');
      if (document.documentElement.getAttribute('data-layout') === 'vertical') {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      if (document.documentElement.getAttribute('data-layout') === 'semibox') {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
      }
      if (humberIcon) {
        humberIcon.classList.add('open');
      }
    } else if (windowSize <= 767) {
      document.body.classList.remove('vertical-sidebar-enable');
      if (document.documentElement.getAttribute('data-layout') !== 'horizontal') {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
      if (humberIcon) {
        humberIcon.classList.add('open');
      }
    }
  }, [visibility, windowSize]);

  const { data: infoPestCompany } = useGetPestCompany();
  useEffect(() => {
    window.addEventListener('resize', resizeSidebarMenu, true);

    return () => {
      window.removeEventListener('resize', resizeSidebarMenu, true);
    };
  }, [resizeSidebarMenu]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const initMenu = () => {
      const ul = document.getElementById('navbar-nav') as HTMLElement;
      ul.getElementsByTagName('a');
    };

    initMenu();
  }, [visibility]);

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, [visibility, dispatch]);
  const setActiveMenu = (item: any) => {
    if (item.link) {
      const matchingMenuItem = menuItems.find((menuItem: any) => menuItem.link === item.link);
      if (matchingMenuItem) {
        setMenuItemsTake(matchingMenuItem.link);
      } else {
        setMenuItemsTake('');
      }
    } else {
      setMenuItemsTake('');
    }
  };
  const { t } = useTranslation();
  if (isActive === false && window.location.pathname === '/r/client-dashboard') {
    return (
      <div>
        {infoPestCompany && (
          <div className="d-flex justify-content-center align-items-center flex-column gap-3 flex-wrap">
            <div className="logo logo-dark">
              <span className="logo-sm">
                {infoPestCompany.logo && <img src={infoPestCompany.logo} alt="" height="22" />}
              </span>
            </div>
            <h5>{infoPestCompany.name}</h5>
          </div>
        )}
        <p className="d-flex justify-content-center align-items-center mx-2 my-3 text-warning active-p">
          {t('ClientSidebar.wait-success')}
        </p>
      </div>
    );
  } else if (isActive === null) {
    return <></>;
  } else {
    return (
      <React.Fragment>
        {(menuItems || []).map((item: any, key: number) => {
          const link =
            item.id === 'myCompany' && companySlug
              ? `${process.env.REACT_APP_BASE_DJANGO_URL}/service-provider/${companySlug}`
              : item.link;

          return (
            <React.Fragment key={key}>
              {item['isHeader'] ? (
                <li className="menu-title">
                  <div className="d-flex justify-content-center align-items-center mx-2 text-center">
                    <span style={{ cursor: 'pointer' }} className="fs-6" onClick={() => onManageEditMapOpen()}>
                      {infoPestCompany?.name || 'Name Company'}
                    </span>
                    {windowSize <= 767 && (
                      <button
                        type="button"
                        className="btn-close mx-3 fs-10"
                        aria-label="Close"
                        onClick={() => dispatch(changeSidebarVisibility('hidden'))}
                      />
                    )}
                  </div>
                </li>
              ) : (
                <div>
                  <li className="nav-item">
                    <Link
                      className={`nav-link menu-link ${menuItemsTake === item.link ? 'background-color-active' : ''}`}
                      to={link ? link : '/#'}
                      onClick={() => setActiveMenu(item)}
                    >
                      <i style={{ color: '#6a37d4' }} className={item.icon} /> <span>{t(item.label)}</span>
                    </Link>
                  </li>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </React.Fragment>
    );
  }
};

HorizontalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default React.memo(HorizontalLayout);
